module.exports = __webpack_public_path__ + "img/anime.06c4a624.svg";